<template>
  <lu-vbox ref="rightPanel" lu-flex :class="{show:rightPanelOpened, 'lu-chrome': isChrome()}" class="rightPanel-container">

    <!-- <div class="rightPanel-background" /> -->

    <lu-hbox class="rightPanel">
      <div class="handle-button" :style="{'top':buttonTop+'px','background-color':theme}" @click="toggleRightPanel" v-if='rightPanelOpened'>
        <i class="el-icon-close" />
      </div>
      <lu-vbox lu-flex class="rightPanel-items">

        <slot />
      </lu-vbox>
    </lu-hbox>
  </lu-vbox>
</template>

<script>
import { LuHbox, LuVbox } from 'lusis-ui'
import { addClass, removeClass } from '@/utils'
import { mapState } from 'vuex';

export default {
  name: 'RightPanel',
  components: { LuHbox, LuVbox },
  props: {
    clickNotClose: {
      default: false,
      type: Boolean
    },
    buttonTop: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      rightPanelOpened: state => state.settingsMonitor.rightPanelOpened
    }),
    theme() {
      return this.$store.state.settings.theme
    }
  },
  watch: {
    rightPanelOpened(value) {
      if (value && !this.clickNotClose) {
        this.addEventClick()
      }
      if (value) {
        addClass(document.body, 'showRightPanel')
      } else {
        removeClass(document.body, 'showRightPanel')
      }
    }
  },
  mounted() {
    this.insertToBody()
  },
  beforeDestroy() {
    const elx = this.$refs.rightPanel
    elx.remove()
  },
  methods: {
    addEventClick() {
      window.addEventListener('click', this.closeSidebar)
    },
    toggleRightPanel() {
      this.$store.dispatch('settingsMonitor/toggleRightPanel')
    },
    closeSidebar(evt) {
      const parent = evt.target.closest('.rightPanel')
      if (!parent) {
        // this.show = false
        window.removeEventListener('click', this.closeSidebar)
      }
    },
    insertToBody() {
      const elx = this.$refs.rightPanel
      const body = document.querySelector('body')
      body.insertBefore(elx, body.firstChild)
    },
    isChrome() {
      return document.querySelector('.lu-app').className.indexOf('lu-chrome') !== -1
    }
  }
}
</script>

<style>
.showRightPanel {
  /* overflow: hidden; */
  position: relative;
  width: calc(100% - 150px);
}
</style>

<style lang="scss" scoped>

.rightPanel-background {
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity .3s cubic-bezier(.7, .3, .1, 1);
  background: rgba(0, 0, 0, .2);
  z-index: -1;
}

.rightPanel {
  width: 100%;
  max-width: 260px;
  max-width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, .05);
  transition: all .25s cubic-bezier(.7, .3, .1, 1);
  transform: translate(100%);
  background: rgb(227, 232, 235);
  // z-index: 40000;
  z-index: 100;
}


.show {
  transition: all .3s cubic-bezier(.7, .3, .1, 1);

  .rightPanel-background {
    z-index: 20000;
    opacity: 1;
    width: 100%;
    height: 100%;
  }

  .rightPanel {
    transform: translate(0);
  }
}

.handle-button {
  width: 48px;
  height: 48px;
  position: absolute;
  left: -48px;
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 0;
  pointer-events: auto;
  cursor: pointer;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}

</style>
